import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import LocalStorageBackend from "i18next-localstorage-backend";
import { initReactI18next } from "react-i18next";

function genRandonNumber(length: number) {
	const chars = "0123456789";
	const charLength = chars.length;
	let result = "";
	for (let i = 0; i < length; i++) {
		result += chars.charAt(Math.floor(Math.random() * charLength));
	}
	return result;
}

const LOCAL_DOMAINS = ["localhost", "127.0.0.1"];
const HASH = genRandonNumber(10);

i18n
	// load translation using http -> see /public/locales
	// learn more: https://github.com/i18next/i18next-http-backend
	.use(ChainedBackend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		fallbackLng: "en",
		// debug only in dev
		debug: LOCAL_DOMAINS.includes(window.location.hostname),

		// Cache the choice to a cookie as well as localStorage: localStorage is invisible to
		// Rails, and the server needs the language to render its own copy (flash messages)
		// in the same one the UI is using. Read back by ApplicationController#switch_locale.
		detection: {
			caches: ["localStorage", "cookie"],
			cookieMinutes: 60 * 24 * 365,
		},

		backend: {
			backends: [
				LocalStorageBackend, // primary
				HttpBackend, // fallback
			],
			backendOptions: [
				// LocalStorageBackend options
				{
					expirationTime: 24 * 60 * 60 * 1000 * 3, // 3 days
					defaultVersion: `v${HASH}`, // generate a new version every build to refresh
				},
				// HttpBackend options
				{
					loadPath: `/locales/{{lng}}/{{ns}}.json?v=${HASH}`, // Force new fetch every build
				},
			],
			cacheHitMode: "refreshAndUpdateStore", // learn more: https://github.com/i18next/i18next-chained-backend,
		},

		// React escapes rendered text itself; escaping here too shows "/" as "&#x2F;".
		interpolation: { escapeValue: false },

		react: {
			useSuspense: false,
			bindI18nStore: "added", // this way, when the HttpBackend delivers new translations (thanks to refreshAndUpdateStore), the UI gets updated
		},
	});

i18n.on("languageChanged", () => {
	document.documentElement.lang = i18n.language;
});

export default i18n;
